import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const YahooDevice11: FC<Props> = (props) => (
  <Root viewBox="0 0 145.78 330.22" {...props}>
    <defs>
      <clipPath id="yahoo1-1_svg__clip-path">
        <path fill="none" d="M3.67 172.7h136.2v90.03H3.67z" />
      </clipPath>
      <style>
        {
          '.yahoo1-1_svg__cls-3{fill:none}.yahoo1-1_svg__cls-2{fill:#fff}.yahoo1-1_svg__cls-3{stroke:#f5f5f5;stroke-miterlimit:10}.yahoo1-1_svg__cls-4{fill:#9e9e9e}.yahoo1-1_svg__cls-12{fill:#eee}.yahoo1-1_svg__cls-13{fill:#f8b02c}'
        }
      </style>
    </defs>
    <g id="yahoo1-1_svg__\u30EC\u30A4\u30E4\u30FC_2" data-name="\u30EC\u30A4\u30E4\u30FC 2">
      <g id="yahoo1-1_svg__\u30EC\u30A4\u30E4\u30FC_1-2" data-name="\u30EC\u30A4\u30E4\u30FC 1">
        <rect width={145.78} height={300.88} rx={21.72} />
        <path
          className="yahoo1-1_svg__cls-2"
          d="M6.28 39.65h132.07v21.96H6.28zM138.27 39.65v-18A14.31 14.31 0 00124 7.33h-14.16v1.92a7.59 7.59 0 01-7.59 7.59H43.14a7.59 7.59 0 01-7.59-7.59V7.33h-15A14.31 14.31 0 006.28 21.64v18z"
        />
        <path
          className="yahoo1-1_svg__cls-2"
          d="M6.28 60.24v219a14.31 14.31 0 0014.31 14.31H124a14.31 14.31 0 0014.31-14.31v-219z"
        />
        <path className="yahoo1-1_svg__cls-3" d="M6.46 36.17h131.65" />
        <circle className="yahoo1-1_svg__cls-4" cx={129.32} cy={25.68} r={4.77} />
        <path d="M114.93 20.41H97.22V31.8h17.71a5.48 5.48 0 005.22-5.7 5.47 5.47 0 00-5.22-5.69z" fill="#1e74ff" />
        <path d="M18.62 20.41a5.47 5.47 0 00-5.22 5.69 5.48 5.48 0 005.22 5.7H96.3V20.41z" fill="#e7e7e7" />
        <path
          d="M6.69 261.89v17.61A14.3 14.3 0 0021 293.81h103.37a14.31 14.31 0 0014.31-14.31v-17.61z"
          fill="#ebe5e1"
        />
        <rect x={53.71} y={286.02} width={34.73} height={3.52} rx={1.76} />
        <circle className="yahoo1-1_svg__cls-4" cx={129.32} cy={272.22} r={4.77} />
        <circle className="yahoo1-1_svg__cls-4" cx={92.43} cy={272.22} r={4.77} />
        <circle className="yahoo1-1_svg__cls-4" cx={53.81} cy={272.22} r={4.77} />
        <circle cx={16.93} cy={272.22} r={4.77} fill="#ec4545" />
        <path fill="#eb4441" d="M6.3 38.46h131.91v131.91H6.3z" />
        <g clipPath="url(#yahoo1-1_svg__clip-path)">
          <path className="yahoo1-1_svg__cls-3" d="M6.63 216.23h131.65M6.63 233.58h131.65M6.63 258.14h131.65" />
          <rect className="yahoo1-1_svg__cls-4" x={7.57} y={220.57} width={23.3} height={9.87} rx={2.63} />
          <rect className="yahoo1-1_svg__cls-4" x={60.44} y={220.57} width={23.3} height={9.87} rx={2.63} />
          <rect className="yahoo1-1_svg__cls-4" x={86.88} y={220.57} width={23.3} height={9.87} rx={2.63} />
          <rect className="yahoo1-1_svg__cls-4" x={113.32} y={220.57} width={23.3} height={9.87} rx={2.63} />
          <rect x={34.01} y={220.57} width={23.3} height={9.87} rx={2.63} fill="#ff5666" />
          <path
            className="yahoo1-1_svg__cls-4"
            d="M21.49 175.19h17.12v17.12H21.49zM41.83 175.19h17.12v17.12H41.83zM62.16 175.19h17.12v17.12H62.16zM82.49 175.19h17.12v17.12H82.49zM102.83 175.19h17.12v17.12h-17.12zM21.49 196.15h17.12v17.12H21.49z"
          />
          <path className="yahoo1-1_svg__cls-12" d="M30.41 239.59h55.23v4.21H30.41zM44.87 246.94h30.11v4.21H44.87z" />
          <rect className="yahoo1-1_svg__cls-13" x={30.4} y={246.17} width={12.13} height={5.14} rx={2.57} />
          <path className="yahoo1-1_svg__cls-4" d="M10.53 237.3h17.12v17.12H10.53z" />
          <path className="yahoo1-1_svg__cls-3" d="M6.63 284.33h131.65" />
          <path className="yahoo1-1_svg__cls-12" d="M30.41 265.78h55.23v4.21H30.41zM44.87 273.13h30.11v4.21H44.87z" />
          <rect className="yahoo1-1_svg__cls-13" x={30.4} y={272.37} width={12.13} height={5.14} rx={2.57} />
          <path className="yahoo1-1_svg__cls-4" d="M10.53 263.5h17.12v17.12H10.53z" />
          <path className="yahoo1-1_svg__cls-3" d="M6.63 308.89h131.65" />
          <path className="yahoo1-1_svg__cls-12" d="M30.41 290.34h55.23v4.21H30.41zM44.87 297.69h30.11v4.21H44.87z" />
          <rect className="yahoo1-1_svg__cls-13" x={30.4} y={296.93} width={12.13} height={5.14} rx={2.57} />
          <path className="yahoo1-1_svg__cls-4" d="M10.53 288.06h17.12v17.12H10.53z" />
          <path className="yahoo1-1_svg__cls-12" d="M30.41 315.38h55.23v4.21H30.41zM44.87 322.73h30.11v4.21H44.87z" />
          <rect className="yahoo1-1_svg__cls-13" x={30.4} y={321.96} width={12.13} height={5.14} rx={2.57} />
          <path
            className="yahoo1-1_svg__cls-4"
            d="M10.53 313.1h17.12v17.12H10.53zM41.83 196.15h17.12v17.12H41.83zM62.16 196.15h17.12v17.12H62.16zM82.49 196.15h17.12v17.12H82.49zM102.83 196.15h17.12v17.12h-17.12z"
          />
        </g>
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();
export default YahooDevice11;
